import {
  Component,
  Output,
  EventEmitter,
  Input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import {
  MatDialog, MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppSettings } from 'src/app/config';
import { LicenceComponent } from '../../../../components/licence/licence.component';
import { AuthService } from '../../../../services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { CharityDataShareServiceService } from '../../../../components/charity/charities/services/charity-data-share-service.service';
import { CharitiesService } from '../../../../components/charity/charities/services/charities.service';
import { MatTableDataSource } from '@angular/material/table';
import { filter, Subscription } from 'rxjs';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { UserLicenseDetailsModel } from '../../../../Data/Models/Users/user-license-details-model';
import { BaseEntityModel } from '../../../../Data/Models/Common/base-entity-model';
import Swal from 'sweetalert2';
import { UsersApiService } from '../../../../Shared/common/users-api.service';
import { LicenceDataShareService } from '../../../../Shared/common/licence-data-share.service';
import { NotesDatashareService } from '../../../../components/charity/notes/services/notes-datashare.service';
import * as CryptoJS from 'crypto-js';
import { UsermanagementService } from '../../../../services/apps/usermanagement/usermanagement.service';
import { RolesModel } from '../../../../Data/Models/Users/roles-model';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
import { LoginapiService } from '../../../../components/auth/Pages/services/loginapi.service';
interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
  color: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule, NgxSpinnerModule,
    MaterialModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = false;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  isCollapse: boolean = false; // Initially hidden
  userName: string;
  userEmail: any;
  currentRegistrainNumber: string;
  currentCharityName: string;
  charitygrid: any
  CharityGrid: any = [];
  isLoadingResults: boolean = false;
  CurrentcharityID: any
  charityID:any
  centralUserID: any;
  noOfCharities: number;
  TableRecordCnt: any;
  isdirty: any = false;
  UserRoleAccess: RolesModel;
  toggleCollpase() {
    this.isCollapse = !this.isCollapse; // Toggle visibility
  }

  showFiller = false;
  ProfilePic: any = null


  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Français',
      code: 'fr',
      icon: '/assets/images/flag/icon-flag-fr.svg',
    },
    {
      language: 'German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.svg',
    },
  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    public authService: AuthService,
    private oauthService: OAuthService,
    private sharedService: CharityDataShareServiceService, private router: Router, public Charities_Service: CharitiesService,
    private userAPIService: UsersApiService,
    private licenceservice: LicenceDataShareService,
    private datashare: NotesDatashareService,
    private _UsermanagementService: UsermanagementService,
    private _config: ConfigurationService,
    private loginService: LoginapiService
  ) {
    translate.setDefaultLang('en');
    const currentUser = localStorage.getItem('currentUser');

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.url;

        if (
          url.includes('settings') ||
          url.includes('charity') ||
          url.includes('reports') ||
          url.includes('profile') ||
          url.includes('submissionHistory') ||
          url.includes('landingpage') ||
          url.includes('dashboard')
        ) {
          this.SwitchCharity = false;
        } else {
          this.SwitchCharity = true;
        }
         if (url.includes('notes')) {
           this.SwitchCharity = true;
        }
      });

  }

  SwitchCharity: boolean = false;
  ngOnInit() {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    this.GetFullCharityGrid()
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.authService.userFullName = parsedUser.firstName + " " + parsedUser.lastName;
      this.authService.userEmail = parsedUser.emailID

    }

    this.authService.currentUserLicenseDetails.subscribe(data => {
      if (data) {
        this.ProfilePic = data.profilePhoto;
      }
    })

    this.sharedService.CharityRegistraionNumber$.subscribe(data => {
      debugger
      this.currentRegistrainNumber = data
      if (data != '' && localStorage.getItem('currentPeriod')!='') {
        this.SwitchCharity = true
      }
      else {
        this.SwitchCharity = false, localStorage.setItem('currentPeriod', '')
      }
    })
    this.sharedService.CharityName$.subscribe(data => {
      debugger
      this.currentCharityName = data
    })
    this.sharedService.charitygrid.subscribe(data => {
      debugger
      this.charitygrid = data
    })

    this.datashare.isdirty$.subscribe(value => {
      this.isdirty = value
    })
  }




  options = this.settings.getOptions();
  private subscription: Subscription;

  onItemSelected() {
    this.subscription = this.sharedService.FY_Year$.subscribe(value => {
      const fyYear = localStorage.getItem('FY_Year');
      if (fyYear) {
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  SpinerShow() {
    this.sharedService.isLoadingResults$.subscribe(data => { this.isLoadingResults = data })

  }


  viewcharity(id: any) {
    debugger
    if (localStorage.getItem("currentCharityID") == id) {
      this.dialog.closeAll();
      return;
    }
    this.dialog.closeAll();
    //localStorage.setItem("currentCharityID", id)
    localStorage.setItem("currentCharityIDFromSwitch", id)
    if (this.router.url.includes(`/charity`)&& false) {       //no need this if condition , 'please check once'
      this.sharedService.triggerveiwCharityMethod.next(); 
    } else {
      localStorage.setItem("IsFromSwitchCharity", '')
      if (!this.isdirty) {
        this.sharedService.updateisLoadingResults(true)
      }
      this.sharedService.isLoadingResults$.subscribe(data => { this.isLoadingResults = data })
      localStorage.setItem('isFromBasicInfo', 'true')

      this.router.navigate(['charity']);

    }
  }


  openCharities(template: any) {
    debugger
    localStorage.setItem("IsFromSwitchCharity", '')
    let dialogRef = this.dialog.open(template, {
      width: '40%', maxWidth: '100%', disableClose: true
    });
    this.CurrentcharityID = localStorage.getItem('currentCharityID')
    this.GetFullCharityGrid(template);
    
  }
  GetFullCharityGrid(type?:any) {
    debugger
    if (localStorage.getItem('CurrentuserID')) {
      this.Charities_Service.GetCharityGrid(localStorage.getItem('CurrentuserID')).subscribe((Response: any) => {
        debugger
        this.CharityGrid = Response;
        this.CharityGrid.sort((a: any, b: any) => a.charityID - b.charityID);

      })
      this.CharityTableData = new MatTableDataSource(this.CharityGrid);
    }



  }
  addcharity(licenceLimit?: any) {
    debugger
    if (!this.isdirty) {
      this.dialog.closeAll();
      const currentUser = localStorage.getItem('currentUser');
      if (currentUser) {
        const parsedUser = JSON.parse(currentUser);
        this.centralUserID = parsedUser.userID;
      }
      localStorage.setItem("IsFromSwitchCharity", 'true')
      if (this.router.url.includes(`/charity`) && false) {////no need this if condition , 'please check once'
        this.sharedService.triggerAddCharityMethod.next();
        localStorage.setItem("currentCharityID", '')
      } else {
        this.userAPIService.getUserLicenseDetails(this.centralUserID).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
          debugger
          if (data.status == 0) {
            if (data.entity != null && data.entity.length > 0) {
              this.noOfCharities = data.entity[0].noOfCharities;
              this.TableRecordCnt = data.entity[0].totalNoofCharitiescreated
              if (this.TableRecordCnt >= this.noOfCharities) {
                localStorage.setItem('isCharityLimitExceed', 'true')
                const message = "You have reached the " + this.noOfCharities + " record limit of your licence. Upgrade your subscription to proceed."
                Swal.fire({
                  html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Licence Exceeded!</h5>  <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">' + message + '</p>',
                  iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showCancelButton: true,
                  cancelButtonText: "Cancel",
                  confirmButtonText: "Upgrade",
                  reverseButtons: true
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.licenceservice.Upgrade('Upgrade');
                  }
                  //  localStorage.setItem('currentPeriod', '');
                });
              } else {
                localStorage.setItem('isCharityLimitExceed', 'false')
                this.router.navigate(['charity']);
                localStorage.setItem("currentCharityID", '');
                this.SwitchCharity = false;
              }
              return;
            }
          }
        })

      }
    } else {
      localStorage.setItem("IsFromSwitchCharity", 'true')
      this.dialog.closeAll();
      this.router.navigate(['charity']);
    }
  }

  displayedColumnsCharity: string[] = [
    'charity name',
    'action',
  ];

  //CharityTableData: any[] = [
  //  { charityname: 'Hope Foundation', status: 'Logged In' },
  //  { charityname: 'Richell Charity', status: 'Login' },
  //  { charityname: 'Codelin Rossie Foundation', status: 'Login' },
  //];
  CharityTableData = new MatTableDataSource(this.CharityGrid);

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }
  logout() {
    this.loginService.logOut('session');
  }
  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him sf',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Hitesh Joined thed Team!',
      subtitle: 'Congratulate him',
    },
  ];
  profiledd = [
    {
      id: 1,
      img: 'wallet',
      color: 'primary',
      title: 'My Profile',
      subtitle: 'Account Settings',
     // link: '/settings/usermanagement',
      action:() =>  this.OpenUserProfile()
    },
    {
      id: 2,
      img: 'shield',
      color: 'success',
      title: 'Licence',
      subtitle: 'View Licence Details',
      action: () => this.dialog.open(LicenceComponent, { width: '40%', maxWidth: '100%', disableClose: true }),
    },
    {
      id: 3,  
      img: 'headphones',
      color: 'error',
      title: 'Andica Support Portal',
      subtitle: 'Contact us',
      link: 'https://support.andica.com/portal/en/home',
      external: true
    },


    {
      id: 4,
      img: 'progress-help',
      color: 'war',
      title: 'FAQs',
      subtitle: 'Contact us',
      link: 'https://www.andica.com/faq.html',
      external: true
    },

    //{
    //  id: 5,
    //  img: 'help',
    //  color: 'war',
    //  title: 'Help',
    //  subtitle: 'Help File',
    //  action: () => {window.open("helpfile", "", "width=4000,height=1000");
    //    }
    //},

  ];

  openHelp() {
    const url = window.location.origin + '/helpfile/copyright'
    window.open(url, '_blank');


    //this.router.navigate([`/help/copyright`]);
  }

  OpenUserProfile() {
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.UserRoleAccess = data.entity[0]
        if (this.UserRoleAccess?.m4View) {
          const secretKey = 'pass123'; // Use a secure key
          const encryptedProfile = CryptoJS.AES.encrypt('MyProfile', secretKey).toString();

          const queryParams = { profile: encryptedProfile };

          if (window.location.href.includes('settings/usermanagement')) {
            this.router.navigate(['settings/Usermanagement'], { queryParams });
          } else {
            this.router.navigate(['settings/usermanagement'], { queryParams });
          }
        } else { return }
      }
    });
  }



OpenUserProfile1() {
  debugger;
  if (this.UserRoleAccess?.m4View) {
    const secretKey = 'pass123'; // Use a secure key
    const encryptedProfile = CryptoJS.AES.encrypt('MyProfile', secretKey).toString();

    const queryParams = { profile: encryptedProfile };

    if (window.location.href.includes('settings/usermanagement')) {
      this.router.navigate(['settings/Usermanagement'], { queryParams });
    } else {
      this.router.navigate(['settings/usermanagement'], { queryParams });
    }
  } else { return }
}

  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/apps/chat',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'Todo App',
      subtitle: 'Completed task',
      link: '/apps/todo',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/apps/invoice',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/apps/calendar',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/apps/contacts',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/apps/tickets',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/apps/email/inbox',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/apps/courses',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/authentication/login',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/authentication/side-register',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/authentication/error',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/apps/notes',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/apps/employee',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/apps/todo',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/theme-pages/treeview',
    },
  ];
  //Help(TopicId: string, SectionId: string, Url: string) {debugger
  //  localStorage.setItem("TopicId", TopicId);
  //  localStorage.setItem("SectionId", SectionId);
  //  localStorage.setItem("Url", Url);
  //  window.open("help", "", `width=${window.screen.width * 0.8},height=${window.screen.height * 0.8},left=100,top=50`);
  //}
  navigateToAndicaCentral() {
    debugger
    const url = this._config.getAndicaCentralApi()
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}

@Component({
  selector: 'search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = navItems;

  navItemsData = navItems.filter((navitem) => navitem.displayName);

  // filtered = this.navItemsData.find((obj) => {
  //   return obj.displayName == this.searchinput;
  // });
}
